import loadingImg from '../general/img/loading.svg';

function Loading(props) {
  return <img src={loadingImg} alt="voltaware loading" width={props.width} />;
}

export default Loading;
